import { Modal } from "antd";
import styled from "styled-components";
import { Button } from "../Button";

export const ModalStyled = styled(Modal)`
  .ant-modal-content {
    background-color: rgb(35, 35, 40);
  }

  .ant-modal-header {
    background-color: rgb(35, 35, 40);
    border-bottom: none;
  }

  .ant-modal-footer {
    border-top: none;
  }
`;

export const ModalButton = styled(Button)`
  button {
    padding: 0.2rem 1.2rem;
  }
`;